<template>
  <div :class="{demons: isDemons, diamond: isDiamond}">
      <template v-if="!$store.state.hideApp">
          <layout v-if="layoutDataReady && !isExport">
              <template id="page-content" slot="page-content">
                  <router-view></router-view>
              </template>
          </layout>
          <div id="export-content" v-else-if="layoutDataReady && isExport">
              <router-view></router-view>
          </div>
          <top-message/>
      </template>
      <div class="load-backdrop" v-if="loadingIndicator.active">
          <div class="popup-load">
              <loading-indicator mode="light"/>
              <div class="text" v-if="loadingIndicator.text">{{ loadingIndicator.text }}</div>
          </div>
      </div>
  </div>
</template>

<script lang="ts">
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import Layout from "./Layout.vue";
    import TopMessage from "./components/TopMessage.vue";
    import LoadingIndicator from "./components/LoadingIndicator.vue";
    import {Getter, State} from "vuex-class";

    @Component({
        components: {LoadingIndicator, TopMessage, Layout},
        metaInfo: {
            title: 'DG Gadget',
            meta: [
                {name: 'themeColor', content: '#0072ff'},
            ],
        }
    })
    export default class App extends Vue {
        @State('layoutDataLoaded') layoutDataReady: boolean;

        @State('loader') loadingIndicator: any;

        @State('loggedIn') loggedIn: any;

        @Getter('isExport') isExport: boolean;

        created() {
            setInterval(() => {
                const exportEl = document.querySelector('.export-fullscreen');

                if(exportEl && 'undefined' !== typeof exportEl)
                {
                    window.parent.postMessage(['setHeight', exportEl.scrollHeight], '*');
                    window.parent.postMessage(['setWidth', exportEl.scrollWidth], '*');
                }
            }, 50);
        }

        get isDemons()
        {
            return false;
        }

        get isDiamond()
        {
            return true;
        }
    }
</script>
